import React from 'react';
import {Icon} from 'semantic-ui-react';

// custom directional arrow icon for react-slick carousel

const CarouselArrow = props => (
  <Icon
    name={`chevron ${props.direction}`}
    className={props.className}
    style={props.style}
    onClick={props.onClick} />
);

export default CarouselArrow;



// WEBPACK FOOTER //
// ./public/components/images/CarouselArrow.jsx